import React from 'react';

export const getPreviewKind = (fileName = "", mimeType = "") => {
  const ext = fileName.split(".").pop()?.toLowerCase() || "";
  const mime = mimeType.toLowerCase();

  if (
    mime.startsWith("image/") ||
    ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(ext)
  ) {
    return "image";
  }

  if (mime === "application/pdf" || ext === "pdf") {
    return "pdf";
  }

  if (
    mime.startsWith("video/") ||
    ["mp4", "webm", "ogg", "mov"].includes(ext)
  ) {
    return "video";
  }

  if (
    mime.startsWith("audio/") ||
    ["mp3", "wav", "aac", "ogg"].includes(ext)
  ) {
    return "audio";
  }

  if (
    mime.startsWith("text/") ||
    ["txt", "csv", "json", "xml"].includes(ext)
  ) {
    return "text";
  }

  if (
    ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext)
  ) {
    return "office";
  }

  return "other";
};

export const buildServerFileUrl = (imageUrl, fileName) => {
  if (!fileName) return '';
  const base = (imageUrl || '').replace(/\/$/, '');
  const path = String(fileName).replace(/^\//, '');
  return `${base}/${path}`;
};

export const buildAttachmentPreview = (row) => {
  if (!row) return null;

  const file = row.file;

  const fileName =
    row.fileName ||
    file?.name ||
    "";

  // Local file
  if (file instanceof File) {
    const url = URL.createObjectURL(file);

    return {
      url,
      blobUrl: url,
      fileName: file.name,
      kind: getPreviewKind(file.name, file.type),
      isRemote: false,
    };
  }

  // Server file
  if (fileName) {
    const imageUrl = process.env.REACT_APP_IMAGE_URL;

    const url =
      row.fileUrl ||
      row.url ||
      buildServerFileUrl(imageUrl, fileName);

    return {
      url,
      fileName,
      kind: getPreviewKind(fileName),
      isRemote: true,
    };
  }

  return null;
};

export const revokePreviewUrl = (preview) => {
  if (preview?.blobUrl) {
    URL.revokeObjectURL(preview.blobUrl);
  }
};
export const AttachmentPreviewBody = ({ preview }) => {
  if (!preview?.url) {
    return (
      <p className="text-center">
        No preview available.
      </p>
    );
  }

  const { url, kind, fileName } = preview;

  switch (kind) {
    case "image":
      return (
        <img
          src={url}
          alt={fileName}
          style={{
            width: "100%",
            maxHeight: "75vh",
            objectFit: "contain",
          }}
        />
      );

    case "pdf":
      return (
        <iframe
          src={url}
          title={fileName}
          style={{
            width: "100%",
            height: "75vh",
            border: 0,
          }}
        />
      );

    case "video":
      return (
        <video
          controls
          style={{
            width: "100%",
            maxHeight: "75vh",
          }}
        >
          <source src={url} />
        </video>
      );

    case "audio":
      return (
        <audio
          controls
          style={{ width: "100%" }}
        >
          <source src={url} />
        </audio>
      );

    case "text":
      return (
        <iframe
          src={url}
          title={fileName}
          style={{
            width: "100%",
            height: "75vh",
            border: 0,
          }}
        />
      );

    case "office":
      return (
        <iframe
          title={fileName}
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url
          )}`}
          style={{
            width: "100%",
            height: "75vh",
            border: 0,
          }}
        />
      );

    default:
      return (
        <div className="text-center p-4">
          <h5>{fileName}</h5>

          <p>
            Preview is not available for this file type.
          </p>

          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="mainbtn"
          >
            Open / Download
          </a>
        </div>
      );
  }
};